import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class CompanyBranchService {
    appUrl = "";
    localAppUrl = "";
    coreUrl = "";
    financeURl = "";
    private headers = new HttpHeaders({ "Content-Type": "application/json" });
    constructor(private http: HttpClient) {
        this.appUrl = environment.apiUrl + "Cases/";
        this.coreUrl = environment.coreUrl;
        this.localAppUrl = environment.localApiUrl;
        this.financeURl = environment.financeURl;
    }

    // getAllCurrencies() {
    //     return this.http
    //         .get<any>(this.localAppUrl + "allCurrencies")
    //         .toPromise()
    //         .then((res) => res);
    // }

    getAllCurrencies() {
        return this.http.get<any>(
            `${environment.appOrgUrl}OrganizationCurrency/GetAllCurrencies`
        );
    }

    getCurrencyById(id) {
        return this.http.get<any>(
            `${environment.appOrgUrl}OrganizationCurrency/${id}`
        );
    }

    getAllCountryCurrencies() {
        return this.http.get<any>(
            this.coreUrl + "CurrencyUnit/GetAllCountryCurrency"
        );
    }

    saveCurrency(obj) {
        return this.http.post<any>(
            `${environment.appOrgUrl}OrganizationCurrency`,
            obj
        );
    }

    updateCurrency(obj) {
        return this.http.put<any>(
            `${environment.appOrgUrl}OrganizationCurrency`,
            obj
        );
    }

    deleteCurrency(id) {
        return this.http.delete<any>(
            `${environment.appOrgUrl}OrganizationCurrency/${id}`
        );
    }

    getAllSettings() {
        return this.http
            .get<any>(this.localAppUrl + "allSettings")
            .toPromise()
            .then((res) => res);
    }

    getAccessControl() {
        return this.http.get<any>( `${environment.appOrgUrl}AccessControl/GetAccessControl`);
    }

    saveAccessControl(updateData) {
        return this.http.post<any>( `${environment.appOrgUrl}AccessControlConfig?AccessControlMasterId=${updateData.id}&isReportHierarchyBased=${updateData.isReportHierarchyBased}`, updateData);
    }

    deleteMultipleAddress(ids:any) {
        return this.http.post<any>( `${environment.appOrgUrl}Organization/Addresses`, ids);
    }
    validateCurrencyPermissions(id: number, isAccount?: boolean): Observable<any> {
        const params = new HttpParams()
            .append(isAccount !== undefined ? 'refId' : 'currencyId', id.toString())
            .append(isAccount !== undefined ? 'isAccount' : '', isAccount?.toString() || '');
    
        return this.http.get<any>(`${this.financeURl}FinancialAccount/CheckReference`, { params });
    }
}
